// extracted by mini-css-extract-plugin
export default {"container":"edit-address_container__l3IM4","inputs-container":"edit-address_inputs-container__hxTaf","button-container":"edit-address_button-container__2IuF0"};